import React from "react";

// Alert Context
export const AlertContext = React.createContext();

// Alert Provider
export const AlertProvider = ({ children }) => {
  // alert state
  const [alert, setAlert] = React.useState([]);

  return (
    <AlertContext.Provider value={{ alert, setAlert }}>
      {children}
    </AlertContext.Provider>
  );
};
